module.exports = __webpack_public_path__ + "img/relax_in.226d02da.svg";